import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import CtasListToolbar from "../ctas/CtasListToolbar";
import CtasListItem from "../ctas/CtasListItem";
import { reportingGoals } from "../../src/reportingGoals";
import { observeStickyOptionsShadow } from "../../utils/stickyOptionsColumn";

const CtasList = (props) => {
  const currentSortMetric = props.sort_by || "created_at_latest";
  const goals = reportingGoals(props.website);
  const rowScroller = useRef(null);

  const applyMetricSort = (metric) => {
    const nextUrl = new URL(window.location.href);
    nextUrl.searchParams.set("sort_by", metric);
    nextUrl.searchParams.delete("page");
    window.location.assign(nextUrl.toString());
  };

  const renderSortableHeading = (label, metric) => (
    <p
      className="ctas-list-row-heading text-xl"
      onClick={() => applyMetricSort(metric)}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          applyMetricSort(metric);
        }
      }}
      role="button"
      tabIndex={0}
      style={{
        color: "#000000",
        cursor: "pointer",
        fontWeight: 400,
      }}
    >
      {label}
      {currentSortMetric === metric ? " ↓" : ""}
    </p>
  );

  const ctas = props.ctas.map((cta, i) => {
    return (
      <CtasListItem
        key={"cta-" + cta.id}
        website={props.website}
        cta={cta}
        list_type={props.list_type}
        role_type={props.role_type}
        plan_type={props.plan_type}
        premimum={props.premium}
        {...props}
      />
    );
  });

  useEffect(() => {
    $('[data-toggle="tooltip"]').tooltip();
  }, []);

  useEffect(() => {
    if (rowScroller.current) {
      return observeStickyOptionsShadow(rowScroller.current);
    }
  }, [props.list_type]);

  return (
    <React.Fragment>
      <div className="row hard-center CtasList smooth">
        <div className="col-xs-12 no-padding-sides">
          <div className="row hard-center">
            <div
              className="col-xs-12 no-padding-left"
              style={{ paddingRight: "0px" }}
            >
              <CtasListToolbar {...props} />
            </div>
          </div>
          {props.list_type == "card" && (
            <div className="row hard-center ctas-list-card-container">
              {ctas}
              <a
                className="new-cta"
                href={`/websites/${props.website.id}/cta/new`}
              >
                <div className="CtasListItemCard card-new ctas-list-card-new">
                  <h3 className="some-vertical-space smooth center">
                    Create Campaign +
                  </h3>
                </div>
              </a>
            </div>
          )}
          {props.list_type == "row" && (
            <div className="col-xs-12">
              <div
                ref={rowScroller}
                className="row hard-center ctas-list-row-container some-vertical-space border-solid border-[1px] border-slate-200 rounded-lg overflow-x-auto"
                style={{ scrollbarWidth: "thin" }}
              >
                <div className="ctas-list-row-content">
                  <div
                    className="col-xs-12 ctas-list-row-header"
                    style={{
                      position: "sticky",
                      top: "5px",
                      paddingTop: "15px",
                      zIndex: 20,
                      marginTop: 0,
                      background: "#fff",
                    }}
                  >
                    <div className="ctas-list-name-column">
                      <div className="ctas-list-preview-link">
                        <p className="ctas-list-row-heading">Preview</p>
                      </div>
                      <div className="ctas-list-name-text">
                        <p className="ctas-list-row-heading">Name</p>
                      </div>
                    </div>
                    <div className="ctas-list-metrics">
                      <div className="ctas-list-metric ctas-list-metric-wide">
                        {renderSortableHeading("Viewers", "views")}
                      </div>
                      <div className="ctas-list-metric ctas-list-metric-wide">
                        {renderSortableHeading("Conversions", "conversions")}
                      </div>
                      <div className="ctas-list-metric ctas-list-metric-wide">
                        {renderSortableHeading("Completions", "completions")}
                      </div>
                      {goals.checkouts && (
                        <div className="ctas-list-metric">
                          {renderSortableHeading("Orders", "orders")}
                        </div>
                      )}
                      {goals.checkouts && (
                        <div className="ctas-list-metric">
                          {renderSortableHeading("Revenue", "revenue")}
                        </div>
                      )}
                      {goals.checkouts && (
                        <div className="ctas-list-metric">
                          {renderSortableHeading("AOV", "aov")}
                        </div>
                      )}
                      {goals.bookings && (
                        <div className="ctas-list-metric">
                          {renderSortableHeading("Bookings", "bookings")}
                        </div>
                      )}
                      {goals.custom && (
                        <div className="ctas-list-metric">
                          {renderSortableHeading(
                            goals.customGoalLabel,
                            "custom_goals"
                          )}
                        </div>
                      )}
                      <div className="ctas-list-campaign-column">
                        <p className="ctas-list-row-heading">Campaign</p>
                      </div>
                      <div className="ctas-list-options-column sticky-options-col"></div>
                    </div>
                  </div>
                  <div className="col-xs-12">{ctas}</div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default CtasList;
